/* ============================================================
   M&H MODERN HUB - brand behaviour
   1. Wishlist (localStorage, no app required)
   2. Reveal-on-scroll
   Written defensively: storage can throw in private mode, so every
   read and write is guarded and the site works with it disabled.
   ============================================================ */

(function () {
  'use strict';

  var KEY = 'mh:wishlist';

  /* ---------- storage ---------- */

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* quota or blocked storage - wishlist degrades to this page only */
    }
  }

  /* ---------- public-ish API ---------- */

  var Wishlist = {
    all: read,

    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },

    toggle: function (handle) {
      var list = read();
      var i = list.indexOf(handle);
      if (i === -1) {
        list.push(handle);
      } else {
        list.splice(i, 1);
      }
      write(list);
      sync();
      document.dispatchEvent(
        new CustomEvent('mh:wishlist:change', { detail: { handle: handle, saved: i === -1, list: list } })
      );
      return i === -1;
    },

    remove: function (handle) {
      var list = read();
      var i = list.indexOf(handle);
      if (i !== -1) {
        list.splice(i, 1);
        write(list);
        sync();
        document.dispatchEvent(
          new CustomEvent('mh:wishlist:change', { detail: { handle: handle, saved: false, list: list } })
        );
      }
    },

    count: function () {
      return read().length;
    }
  };

  window.MHWishlist = Wishlist;

  /* ---------- keep every button and the header badge in sync ---------- */

  function sync() {
    var list = read();

    document.querySelectorAll('[data-mh-wishlist]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-mh-wishlist')) !== -1;
      var want = on ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== want) btn.setAttribute('aria-pressed', want);

      var label = on ? btn.getAttribute('data-label-on') : btn.getAttribute('data-label-off');
      if (label) {
        if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
        var text = btn.querySelector('[data-mh-wishlist-text]');
        if (text && text.textContent !== label) text.textContent = label;
      }
    });

    document.querySelectorAll('[data-mh-wishlist-count]').forEach(function (el) {
      var n = String(list.length);
      if (el.textContent !== n) el.textContent = n;
      var hide = list.length === 0;
      if (hide && !el.hasAttribute('hidden')) el.setAttribute('hidden', '');
      if (!hide && el.hasAttribute('hidden')) el.removeAttribute('hidden');
    });
  }

  /* One delegated listener covers cards rendered later by
     quick-add, filtering, pagination or section rendering. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-mh-wishlist]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    Wishlist.toggle(btn.getAttribute('data-mh-wishlist'));
  });

  /* ---------- reveal on scroll ---------- */

  var reveal;

  function observe(root) {
    var targets = (root || document).querySelectorAll('.mh-reveal:not(.mh-in)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('mh-in');
      });
      return;
    }

    if (!reveal) {
      reveal = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('mh-in');
            reveal.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
      );
    }

    targets.forEach(function (el) {
      reveal.observe(el);
    });
  }

  /* ---------- boot ---------- */

  function init(root) {
    sync();
    observe(root);
  }

  /* Only now, with JS confirmed running, is it safe to let CSS hide
     .mh-reveal elements. If this file never executes, nothing hides. */
  document.documentElement.classList.add('mh-js');

  /* Belt and braces: reveal everything shortly after load no matter what,
     so a failed observer can never leave the page blank. */
  window.setTimeout(function () {
    document.querySelectorAll('.mh-reveal:not(.mh-in)').forEach(function (el) {
      el.classList.add('mh-in');
    });
  }, 2500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  /* Dawn dispatches this after filtering and cart updates swap markup in */
  ['mh:refresh', 'shopify:block:select'].forEach(function (name) {
    document.addEventListener(name, function () {
      init();
    });
  });

  /* Facets, pagination and quick-add all finish with one of these. */
  ['shopify:section:unload', 'pageshow', 'popstate'].forEach(function (name) {
    window.addEventListener(name, function () {
      init();
    });
  });
})();

/* ============================================================
   Size guide disclosure - delegated so it survives variant
   re-renders on the product page.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.mh-sizeguide__trigger');
    if (!trigger) return;

    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    var open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', open ? 'false' : 'true');

    if (open) {
      panel.setAttribute('hidden', '');
    } else {
      panel.removeAttribute('hidden');
    }
  });
})();
